
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boleto",
      function () {
        return require("private-next-pages/boleto.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boleto"])
      });
    }
  